import $ from 'jquery';

function toggle(event) {
  const $btn = $(event.currentTarget);
  const $container = $btn.closest('.js-toggle-container');
  const $content = $container.find('.js-toggle-content').first();

  window.requestAnimationFrame(_ => {
    $content.slideToggle({
      duration: 250
    });
    $container.toggleClass('open');
  });
}

$(_ => {
  $('.js-toggle-btn').click(toggle);
});